import { useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { SmartDiaryEntry } from 'modules/smartDiary/smartDiaryNotes';
import { DiaryEntrySyncStatus } from 'graphql/types';

export const useFormUpdateDirtyState = ({
  smartEntries
}: {
  smartEntries: SmartDiaryEntry[];
}): boolean => {
  const { formState, reset } = useFormContext();
  const hasPendingSyncEntry = useMemo(
    () =>
      smartEntries.some(
        (note) =>
          note.syncStatus === DiaryEntrySyncStatus.DeletePending ||
          note.syncStatus === DiaryEntrySyncStatus.UpdatePending
      ),
    [smartEntries]
  );

  useEffect(() => {
    if (!formState.isDirty && hasPendingSyncEntry) {
      //https://github.com/react-hook-form/react-hook-form/discussions/4052
      reset({}, { keepValues: true, keepDirty: true });
    }
  }, [reset, formState.isDirty, hasPendingSyncEntry]);

  return useMemo(() => formState.isDirty, [formState.isDirty]);
};
